import { gql } from 'graphql-request'

export const menuDetailQuery = gql`
    query companyBranches($branchId: ID!) {
        wareCategories(
            companyBranch: $branchId
            wareCategoryType: MAIN
            enabled: true
            isAvailable: true
            orderOriginCategory: DOVEZE
            withoutPromoTags: [HIDDEN_FROM_STANDARD]
        ) {
            recipes(enabled: true, isAvailable: true) {
                recipeTags {
                    id
                    label
                    color
                    image
                    imagePreview: image(width: 200, height: 200)
                }
            }
        }
    }
`
